import type { Category } from '~/stores/CategoriesStore';

import { ProductsCarouselWithBackground } from './shared/ProductsCarouselWithBackground';

interface ProductsCarouselSliderWithBackgroundProps
  extends Omit<React.ComponentPropsWithoutRef<'div'>, 'children'> {
  category: Category;
  priority?: boolean;
}

/** Ratios of the boxes the layout reserves, mirroring the `aspect-*` classes. */
const MOBILE_ASPECT_RATIO = 328 / 520;
const DESKTOP_ASPECT_RATIO = 1400 / 878;

const mobileClass =
  'aspect-328/520 justify-end rounded-6.5 bg-graphic-regular-brand p-4';
const carouselClass =
  'p-4 aspect-1400/878 bg-graphic-regular-brand overflow-hidden rounded-6.5 flex items-end';

export const ProductsCarouselSliderWithBackground: React.FC<
  ProductsCarouselSliderWithBackgroundProps
> = (props) => (
  <ProductsCarouselWithBackground
    {...props}
    mobileAspectRatio={MOBILE_ASPECT_RATIO}
    desktopAspectRatio={DESKTOP_ASPECT_RATIO}
    mobileClassName={mobileClass}
    carouselClassName={carouselClass}
  />
);
